/**
 * @generated SignedSource<<ccdd42f6408a0a65f44081276e7e9072>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "%future added value";
export type ValidateCanUserDeleteTaskInput = {
  taskId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ValidateCanUserDeleteTaskMutation$variables = {
  input: ValidateCanUserDeleteTaskInput;
};
export type ValidateCanUserDeleteTaskMutation$data = {
  readonly validateCanUserDeleteTask: {
    readonly userCanDeleteTask: boolean | null;
    readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
  } | null;
};
export type ValidateCanUserDeleteTaskMutation = {
  variables: ValidateCanUserDeleteTaskMutation$variables;
  response: ValidateCanUserDeleteTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateCanUserDeleteTaskPayload",
    "kind": "LinkedField",
    "name": "validateCanUserDeleteTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userCanDeleteTask",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userCantDeleteTaskReason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateCanUserDeleteTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateCanUserDeleteTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ace4783f8a79bb694cd617f61175abcb",
    "id": null,
    "metadata": {},
    "name": "ValidateCanUserDeleteTaskMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateCanUserDeleteTaskMutation(\n  $input: ValidateCanUserDeleteTaskInput!\n) {\n  validateCanUserDeleteTask(input: $input) {\n    userCanDeleteTask\n    userCantDeleteTaskReason\n  }\n}\n"
  }
};
})();

(node as any).hash = "42b34f287aff9a3091d7a852eab032b6";

export default node;
